<template>
    <modal :show.sync="is_show" modalClasses="drawer-view-net-income-modal">
        <h6 slot="header" class="modal-title">Net Income Details</h6>
        <div class="table-net-income-details" v-if="customer && customer.customer_joint_profiles">
            <b-table-simple bordered responsive>
                <b-thead>
                    <b-tr>
                        <b-th class="text-white">Name</b-th>
                        <b-th width="150px" class="text-white" v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.name | shortenText(20) }}</b-th>
                        <b-th width="150px">Total</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-if="customer.customer_joint_profiles.find((item) => item.main_income.business_income_type === 'Borang B')">
                        <b-th scope="row">Borang B</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">
                            <span v-if="profile.main_income.income_type_id === 2 && profile.main_income.business_income_type === 'Borang B'">
                                {{ profile.main_income.company_bank_statement | moneyFormatter }}
                            </span>
                            <span v-else>0.00</span>
                        </b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.company_bank_statement ? item.main_income.company_bank_statement : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr v-if="customer.customer_joint_profiles.find((item) => item.main_income.business_income_type === 'Company Bank Statement')">
                        <b-th scope="row">Company Bank Statement</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">
                            <span v-if="profile.main_income.income_type_id === 2 && profile.main_income.business_income_type === 'Company Bank Statement'">
                                {{ profile.main_income.company_bank_statement | moneyFormatter }}
                            </span>
                            <span v-else>0.00</span>
                        </b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.company_bank_statement ? item.main_income.company_bank_statement : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Salary</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">
                            <span v-if="profile.main_income.income_type_id !== 2">
                                {{ profile.main_income.monthly_salary | moneyFormatter }}
                            </span>
                            <span v-else>0.00</span>
                        </b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.monthly_salary ? item.main_income.monthly_salary : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Fixed Allowance</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.fixed_allowance | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.fixed_allowance ? item.main_income.fixed_allowance : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Average Variable Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.av_var_inc | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.av_var_inc ? item.main_income.av_var_inc : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Average Commission Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.av_com_inc | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.av_com_inc ? item.main_income.av_com_inc : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Average Bonus Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.av_bonus_inc | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.av_bonus_inc ? item.main_income.av_bonus_inc : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Rental Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.total_rental_inc | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.total_rental_inc ? item.main_income.total_rental_inc : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Other Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.total_other_inc | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.total_other_inc ? item.main_income.total_other_inc : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr variant="primary" class="font-weight-bolder">
                        <b-th scope="row">Gross Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.gross_income | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow border-0">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.gross_income ? item.main_income.gross_income : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">Income Tax</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.income_tax | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.income_tax ? item.main_income.income_tax : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr  v-if="customer.incomes.main.income_type_id === 3">
                        <b-th scope="row">Payslip Deduction</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">
                            <span v-if="profile.main_income.income_type_id === 3">
                                {{ profile.main_income.total_other_deduction | moneyFormatter }}
                            </span>
                            <span v-else>0.00</span>
                        </b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.total_other_deduction ? item.main_income.total_other_deduction : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">EPF</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.epf | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.epf ? item.main_income.epf : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">SOCSO</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.sosco | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.sosco ? item.main_income.sosco : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                    <b-tr variant="danger" class="font-weight-bolder">
                        <b-th scope="row">Net Income</b-th>
                        <b-td v-for="(profile,index) in customer.customer_joint_profiles" :key="index">{{ profile.main_income.net_income | moneyFormatter }}</b-td>
                        <b-td class="bg-light-yellow border-0">
                            {{ customer.customer_joint_profiles.reduce((total, item) => 
                                total + parseFloat(item.main_income.net_income ? item.main_income.net_income : 0), 0)
                                | moneyFormatter 
                            }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <small class="text-break">*Bonus, Rental and Other Income are added after Net Income.</small>
        </div>
        <div slot="footer"></div>
    </modal>
</template>
<style scoped>
.bg-light-yellow{
    background: #FFF8B4;
}
</style>
<script>
    import { Table, TableColumn } from 'element-ui'

    export default {
        props: ['customer'],
        components: {
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data(){
            return{
                is_show: false
            }
        },
        computed: {
        },
        methods:{
            toggleView() {
                this.is_show = !this.is_show;
            }
        }
    }
</script>